import { AxiosResponse } from "axios";
import { call, delay, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddPracticeExam,
  successaddPracticeExam,
} from "./AddPracticeExamSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  IPracticeExam,
  IPracticeExamlistID,
} from "../../../Pages/PracticeExam/IPracticeExam";
import {
  failuredeletePracticeExam,
  successdeletePracticeExam,
} from "./DeletePracticeExamSlice";
import {
  failurelistPracticeExam,
  successlistPracticeExam,
} from "./ListPracticeExamSlice";
import {
  failureEditPracticeExam,
  successEditPracticeExam,
} from "./EditPracticeExamSlice";
import {
  failurelistInstructionPracticeExamID,
  successlistInstructionPracticeExamID,
} from "./ListinstructionPracticeExamIDSlice";
import { IAPIResponse } from "../../interfaces/IAPIResponse";
import {
  failurelistPracticeExamID,
  successlistPracticeExamID,
} from "./ListPracticeExamIDSlice";
import {
  IEvaluationPractice,
  IEvaluationPracticewritingExam,
} from "../../../Pages/Exam/IExam";
import {
  failurelistEvaluationPractice,
  successlistEvaluationPractice,
} from "./ListEvaluationPracticeSlice";
import {
  failurelistEvaluationPracticewritingExam,
  successlistEvaluationPracticewritingExam,
} from "./ListEvaluationPracticewritingExamSlice";

// list exam id

const ListPracticeExamIDApi = (action: PayloadAction<IPracticeExamlistID>) => {
  const { student_test_id } = action.payload;

  return api.get("/api/exam/startTest", {
    params: {
      student_test_id
      // created_on, 
      // updated_on, 
    },
  });
};

export function* ListPracticeExamIDCall(
  action: PayloadAction<IPracticeExamlistID>
) {
  while (true) {
    try {
      const response: AxiosResponse<IAPIResponse<IPracticeExamlistID>> =
        yield call(ListPracticeExamIDApi, action);
      if (response.data.data) {
        yield put(successlistPracticeExamID(response.data));
        break;
      }
      yield delay(10000);
    } catch (error) {
      yield put(failurelistPracticeExamID(error));
    }
  }
}

// evaluation
const ListEvaluationPracticeApi = (
  action: PayloadAction<IEvaluationPractice>
) => {
  return api.get("/api/exam/testevaluation", { params: action.payload });
};

export function* ListEvaluationPracticeCall(
  action: PayloadAction<IEvaluationPractice>
) {
  yield delay(1000);
  for (let i = 0; i < 5; i++) {
    try {
      const response: AxiosResponse = yield call(
        ListEvaluationPracticeApi,
        action
      );

      const data = response?.data;

      // 🔥 CHECK API ERROR RESPONSE
      if (data?.status === false && data?.status_code === 404) {
        if (i < 4) {
          yield delay(2000);
          continue;
        }
        yield put(failurelistEvaluationPractice(data));
        window.location.replace("/examhistory");
        return;
      }

      yield put(successlistEvaluationPractice(data));
      return;
    } catch (error: any) {
      const errData = error?.response?.data;

      // 🔥 CHECK AXIOS ERROR RESPONSE
      if (errData?.status === false && errData?.status_code === 404) {
        if (i < 4) {
          yield delay(2000);
          continue;
        }
        yield put(failurelistEvaluationPractice(errData));
        window.location.replace("/examhistory");
        return;
      }

      if (i < 4) {
        yield delay(2000);
        continue;
      }
      yield put(failurelistEvaluationPractice(error));
      return;
    }
  }
}

// evaluation Writing exam
const ListEvaluationPracticewritingExamApi = (
  action: PayloadAction<IEvaluationPracticewritingExam>
) => {
  return api.post("/api/exam/writing/evaluation", action.payload);
};

export function* ListEvaluationPracticewritingExamCall(
  action: PayloadAction<IEvaluationPracticewritingExam>
) {
  yield delay(1000);
  for (let i = 0; i < 5; i++) {
    try {
      const response: AxiosResponse = yield call(
        ListEvaluationPracticewritingExamApi,
        action
      );
      const data = response?.data;

      if (data?.status === false && data?.status_code === 404) {
        if (i < 4) {
          yield delay(2000);
          continue;
        }
        yield put(failurelistEvaluationPracticewritingExam(data));
        window.location.replace("/examhistory");
        return;
      }

      yield put(successlistEvaluationPracticewritingExam(response.data));
      return;
    } catch (error: any) {
      const errData = error?.response?.data;

      // 🔥 CHECK AXIOS ERROR RESPONSE
      if (errData?.status === false && errData?.status_code === 404) {
        if (i < 4) {
          yield delay(2000);
          continue;
        }
        yield put(failurelistEvaluationPracticewritingExam(errData));
        window.location.replace("/examhistory");
        return;
      }

      if (i < 4) {
        yield delay(2000);
        continue;
      }
      yield put(failurelistEvaluationPracticewritingExam(error));
      return;
    }
  }
}

// list instruction exam id
const ListInstructionPracticeExamIDApi = (
  action: PayloadAction<IPracticeExamlistID>
) => {
  return api.get("/api/exam/testinstruction", { params: action.payload });
};

export function* ListInstructionPracticeExamIDCall(
  action: PayloadAction<IPracticeExamlistID>
) {
  try {
    const response: AxiosResponse = yield call(
      ListInstructionPracticeExamIDApi,
      action
    );
    yield put(successlistInstructionPracticeExamID(response.data));
  } catch (error) {
    yield put(failurelistInstructionPracticeExamID(error));
  }
}

// list
const ListPracticeExamApi = () => {
  return api.get("/api/exam/");
};

export function* ListPracticeExamCall() {
  try {
    const response: AxiosResponse = yield call(ListPracticeExamApi);
    yield put(successlistPracticeExam(response.data));
  } catch (error) {
    yield put(failurelistPracticeExam(error));
  }
}

// add
const AddPracticeExamApi = (action: PayloadAction<IPracticeExam>) => {
  return api.post("/api/exam/create", action.payload);
};

export function* AddPracticeExamCall(action: PayloadAction<IPracticeExam>) {
  try {
    const response: AxiosResponse = yield call(AddPracticeExamApi, action);
    yield put(successaddPracticeExam(response.data));
  } catch (error) {
    yield put(failureaddPracticeExam(error));
  }
}

// edit
const EditPracticeExamApi = (action: PayloadAction<IPracticeExam>) => {
  return api.put("/api/exam/update", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditPracticeExamCall(action: PayloadAction<IPracticeExam>) {
  try {
    const response: AxiosResponse = yield call(EditPracticeExamApi, action);
    yield put(successEditPracticeExam(response.data));
  } catch (error) {
    yield put(failureEditPracticeExam(error));
  }
}

// delete
const DeletePracticeExamApi = (action: PayloadAction<number>) => {
  return api.delete("/api/exam/delete", {
    params: { id: action.payload },
  });
};

export function* DeletePracticeExamCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeletePracticeExamApi, action);
    yield put(successdeletePracticeExam(response.data));
  } catch (error) {
    yield put(failuredeletePracticeExam(error));
  }
}
